import type { ReactNode } from "react"
import { IntlProvider } from "react-intl"
import { useLocale } from "./locale"
import { defaultLocale, messagesByLocale } from "./messages"

type AppI18nProviderProps = {
  children: ReactNode
}

export function AppI18nProvider({ children }: AppI18nProviderProps) {
  const { locale } = useLocale()

  return (
    <IntlProvider
      defaultLocale={defaultLocale}
      locale={locale}
      messages={messagesByLocale[locale]}
      onError={(error) => {
        if (error.code === "MISSING_TRANSLATION") return
        console.error(error)
      }}
    >
      {children}
    </IntlProvider>
  )
}
